/**
 * Returns the number of days in one month
 *
 * @note January is 0, December is 11
 */
export function getDaysInMonth(year: number, month: number) {
    const date = new Date(year);
    date.setMonth(month);
    date.setDate(40);
    return 40 - date.getDate();
}

export function isToday(date: Date) {
    const today = new Date();
    return isSameDay(date, today);
}

export function isSameDay(date: Date, otherDate: Date) {
    return (
        date.getDate() === otherDate.getDate() &&
        date.getMonth() === otherDate.getMonth() &&
        date.getFullYear() === otherDate.getFullYear()
    );
}

/**
 * Give back the "rounded" hours and minutes from a date
 * By default, rounds time to the nearest half hour
 */
export function roundTime(date: Date, roundTo: number = 30) {
    const minutes = date.getMinutes();
    const hours = date.getHours();
    const m = (((minutes + 7.5) / roundTo) * roundTo) % 60;
    const roundedHours = m > 52 ? (hours === 23 ? 0 : hours + 1) : hours;
    const roundedMinutes = (Math.round(minutes / roundTo) * roundTo) % 60;
    const roundedDate = new Date(date);
    roundedDate.setHours(roundedHours);
    roundedDate.setMinutes(roundedMinutes);
    return roundedDate;
}
